import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";
import qs from "qs";

const url = process.env.REACT_APP_API_BASE_URL;
const ndovuUrl = process.env.REACT_APP_API_REPORT_URL;

const initialState = {
  loading: false,
  loadingGrid: false,
  loadingBal: false,
  loadingGenerateReport: false,
  countryData: [],
  genderData: [],
  staffGradeData: [],
  staffPositionByGrade: [],
  staffTerm: [],
  staffCategory: [],
  payrollType: [],
  coBranch: [],
  depts: [],
  sections: [],
  staffStatus: [],
  socialRel: [],
  staffPosition: [],
  fiscalYear: [],
  fiscalPeriod: [],
  bank: [],
  bankBranch: [],
  slipHeader: [],
  prItem: [],
  prItp: [],
  glAccount: [],
  prFormulas: [],
  taxRate: [],
  nhifRate: [],
  leaveType: [],
  leaveDay: [],
  leaveSchedule: [],
  fiscalP: [],
  leaveTypeAnl: [],
  leaveApp: [],
  staffBank: [],
  staffExempt: [],
  itemb: [],
  prWefHdr: [],
  activeFnPrd: [],
  prWefDtls: {},
  staffItem: [],
  activeFiscYear: [],
  activeFiscMonth: [],
  prSlipMsg: [],
  fiscPeriodsII: [],
  staffNetPays: [],
  casualType: [],
  casualProfile: [],
  attendance: [],
  casualPayment: [],
  casualPaymentDetails: [],
  userMainScreen: [],
  assignedRoles: [],
  reportTree: [],
  lovData: [],
  lovGrid: [],
  attendanceEntries: [],
  attendanceDetails: [],
  ndovuWallet: [],
  organization: {},
  paymentHeader: [],
  paymentDetails: [],
  walletUsers: [],
  shiftSchedule: [],
  shiftType: [],
  locationDetails: [],
  orgCode: "",
  orgWalletCode: "",
  personnelSummary: [],
  balances: "",
  MBs: "",
  tariffs: [],
  thirdPartyData: [],
  connectedUserData: [],
  userActivityData: [],

  personnelSummary: [],
  balances: "",
  MBs: "",
  tariffs: [],
  casualData: [],
  storeItemData: [],
  itemLedgerData: [],
  fixedAssetsData: [],
  storeRequestData: [],
  assetTransferData: [],
  auditData: [],
  shiftReq: [],
  organogram: [],

  coBranchCount: 0,
  deptsCount: 0,
  sectionsCount: 0,
  staffStatusCount: 0,
  staffGradeDataCount: 0,
  staffPositionCount: 0,
  staffTermCount: 0,
  staffCategoryCount: 0,
  payrollTypeCount: 0,
  fiscalYearCount: 0,
  fiscalPeriodCount: 0,
  bankCount: 0,
  bankBranchCount: 0,
  slipHeaderCount: 0,
  prItemCount: 0,
  prItpCount: 0,
  glAccountCount: 0,
  prFormulasCount: 0,
  taxRateCount: 0,
  nhifRateCount: 0,
  leaveTypeCount: 0,
  leaveDayCount: 0,
  leaveScheduleCount: 0,
  fiscalPCount: 0,
  leaveTypeAnlCount: 0,
  leaveAppCount: 0,
  staffBankCount: 0,
  staffExemptCount: 0,
  itembCount: 0,
  prWefHdrCount: 0,
  activeFnPrdCount: 0,
  prWefDtlsCount: 0,
  staffItemCount: 0,
  activeFiscYearCount: 0,
  activeFiscMonthCount: 0,
  prSlipMsgCount: 0,
  fiscPeriodsIICount: 0,
  staffNetPaysCount: 0,
  casualTypeCount: 0,
  casualProfileCount: 0,
  attendanceCount: 0,
  casualPaymentCount: 0,
  casualPaymentDetailsCount: 0,
  userMainScreenCount: 0,
  attendanceEntriesCount: 0,
  attendanceDetailsCount: 0,
  paymentDetailsCount: 0,
  paymentHeaderCount: 0,
  walletUsersCount: 0,
  shiftScheduleCount: 0,
  shiftTypeCount: 0,
  casualCount: 0,
  storeItemCount: 0,
  itemLedgerCount: 0,
  fixedAssetsCount: 0,
  storeRequestCount: 0,
  assetTransferCount: 0,
  auditCount: 0,
  shiftReqCount: 0,

  data: {},
  count: {},
};


export const fetchData = createAsyncThunk(
  "fetch/fetchData",
  async (data, { rejectWithValue }) => {
    const { url, ...body } = data;
 
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axiosInstance({
        url,
        method: "POST",
        data: Object.keys(body).length ? body : null,
      }); 
      if (!response.data.success) {
        return {
          key: url,
          data: [],
          total: 0,
        };
      }

      return {
        key: url,
        data: response?.data?.data?.result,
        total: response?.data?.total,
      }; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
 


export const fetchCountry = createAsyncThunk(
  "dropdwonSlice/fetchCountry",
  async () => {
    const res = await axiosInstance
      .get(`${url}/hr/fetchCountry.action`)
      .then((res) => res.data?.data?.result);
    return res;
  }
);

export const fetchGender = createAsyncThunk(
  "dropdwonSlice/fetchGender",
  async () => {
    const res = await axiosInstance
      .get(`${url}/hr/fetchGender.action`)
      .then((res) => res.data?.data?.result);
    return res;
  }
);

export const fetchStaffStatus = createAsyncThunk(
  "dropdwonSlice/fetchStaffStatus",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffStatus.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchStaffGrade = createAsyncThunk(
  "dropdwonSlice/fetchStaffGrade",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffGrade.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchStaffPositionByGrade = createAsyncThunk(
  "dropdwonSlice/fetchStaffPositionByGrade",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffPositionByGrade.action?sgId_id=${
          data?.sgId_id ?? null
        }`
      )
      .then((res) => res.data?.data?.result);
    return res;
  }
);
export const fetchStaffTerm = createAsyncThunk(
  "dropdwonSlice/fetchStaffTerm",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffTerm.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchStaffCategory = createAsyncThunk(
  "dropdwonSlice/fetchStaffCategory",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffCategory.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchPayrollType = createAsyncThunk(
  "dropdwonSlice/fetchPayrollType",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPayrollType.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchCoBranch = createAsyncThunk(
  "dropdwonSlice/fetchCoBranch",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchCoBranch.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchDepts = createAsyncThunk(
  "dropdwonSlice/fetchDepts",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchDepts.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchSections = createAsyncThunk(
  "dropdwonSlice/fetchSections",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchSections.action?coDeptid_id=${
          data?.coDeptid_id ?? ""
        }&limit=${data?.limit ?? null}&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchSocialRel = createAsyncThunk(
  "dropdwonSlice/fetchSocialRel",
  async () => {
    const res = await axiosInstance
      .get(`${url}/hr/fetchSocialRel.action`)
      .then((res) => res.data?.data?.result);
    return res;
  }
);

export const fetchStaffPosition = createAsyncThunk(
  "dropdwonSlice/fetchStaffPosition",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffPosition.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchFiscYear = createAsyncThunk(
  "dropdwonSlice/fetchFiscYear",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchFiscYear.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchFiscPeriods = createAsyncThunk(
  "dropdwonSlice/fetchFiscPeriods",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchFiscPeriods.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchFiscPeriod = createAsyncThunk(
  "dropdwonSlice/fetchFiscPeriod",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchFiscPeriod.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchBank = createAsyncThunk(
  "dropdwonSlice/fetchBank",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchBank.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchBankBranch = createAsyncThunk(
  "dropdwonSlice/fetchBankBranch",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchBankBranch.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchSlipHeader = createAsyncThunk(
  "dropdwonSlice/fetchSlipHeader",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchSlipHeader.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPrItem = createAsyncThunk(
  "dropdwonSlice/fetchPrItem",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPrItem.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria}&txtSearch=${data?.txtSearch}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPrItp = createAsyncThunk(
  "dropdwonSlice/fetchPrItp",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPrItp.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchGlAccount = createAsyncThunk(
  "dropdwonSlice/fetchGlAccount",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchGlAccount.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPrFormulas = createAsyncThunk(
  "dropdwonSlice/fetchPrFormulas",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPrFormulas.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchTaxRate = createAsyncThunk(
  "dropdwonSlice/fetchTaxRate",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchTaxRate.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchNhifRate = createAsyncThunk(
  "dropdwonSlice/fetchNhifRate",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchNhifRate.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLeaveType = createAsyncThunk(
  "dropdwonSlice/fetchLeaveType",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchLeaveType.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchLeaveTypeAnl = createAsyncThunk(
  "dropdwonSlice/fetchLeaveTypeAnl",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchLeaveTypeAnl.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLeaveDay = createAsyncThunk(
  "dropdwonSlice/fetchLeaveDay",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchLeaveDay.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLeaveSchedule = createAsyncThunk(
  "dropdwonSlice/fetchLeaveSchedule",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchLeaveSchedule.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLeaveApp = createAsyncThunk(
  "dropdwonSlice/fetchLeaveApp",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchLeaveApp.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchStaffBank = createAsyncThunk(
  "dropdwonSlice/fetchStaffBank",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffBank.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria}&txtSearch=${data?.txtSearch}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchStaffExempt = createAsyncThunk(
  "dropdwonSlice/fetchStaffExempt",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffExempt.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria}&txtSearch=${data?.txtSearch}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchItem = createAsyncThunk(
  "dropdwonSlice/fetchItem",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchItem.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchPrWefHdr = createAsyncThunk(
  "dropdwonSlice/fetchPrWefHdr",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPrWefHdr.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchActiveFnPrd = createAsyncThunk(
  "dropdwonSlice/fetchActiveFnPrd",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchActiveFnPrd.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchPrWefDtls = createAsyncThunk(
  "dropdwonSlice/fetchPrWefDtls",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPrWefDtls.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }&wefhId_id=${data?.wefhId_id}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchStaffItem = createAsyncThunk(
  "dropdwonSlice/fetchStaffItem",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffItem.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchActiveFiscYear = createAsyncThunk(
  "dropdwonSlice/fetchActiveFiscYear",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchActiveFiscYear.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchFiscPeriodsII = createAsyncThunk(
  "dropdwonSlice/fetchFiscPeriodsII",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchFiscPeriodsII.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchActiveFiscMonth = createAsyncThunk(
  "dropdwonSlice/fetchActiveFiscMonth",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchActiveFiscMonth.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPrSlipMsg = createAsyncThunk(
  "dropdwonSlice/fetchPrSlipMsg",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchPrSlipMsg.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchStaffNetPays = createAsyncThunk(
  "dropdwonSlice/fetchStaffNetPays",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchStaffNetPays.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&fpYear=${data?.fpYear}&fpMonth=${
          data?.fpMonth
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchCasualType = createAsyncThunk(
  "dropdwonSlice/fetchCasualType",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchCasualType.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchCasualProfile = createAsyncThunk(
  "dropdwonSlice/fetchCasualProfile",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/attendance/fetchCasualProfile.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchAttendance = createAsyncThunk(
  "dropdwonSlice/fetchAttendance",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchAttendanceCasuals.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&dateFilter=${
          data?.dateFilter ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchCasualPayment = createAsyncThunk(
  "dropdwonSlice/fetchCasualPayment",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchCasualPayment.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchCasualPaymentDetails = createAsyncThunk(
  "dropdwonSlice/fetchCasualPaymentDetails",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchCasualPaymentDetails.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&cpId=${data?.cpId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchUserMainScreen = createAsyncThunk(
  "dropdwonSlice/fetchUserMainScreen",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/usr/fetchUserMainScreen.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchAssignedRoles = createAsyncThunk(
  "dropdwonSlice/fetchAssignedRoles",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/usr/fetchAssignedRoles.action?userId=${data?.userId}&node=${
          data?.node ?? "xnode_1"
        }`
      )
      .then((res) => res.data);
    return res;
  }
);
export const assignRole = createAsyncThunk(
  "dropdwonSlice/assignRole",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/usr/assignRole.action?rolesId=${data?.rolesId}&userId=${data?.userId}&nodeValue=${data?.nodeValue}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchReportTree = createAsyncThunk(
  "dropdwonSlice/fetchReportTree",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/myReports/fetchReportTree.action?node=${
          data?.node ?? "xnode-69"
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLovData = createAsyncThunk(
  "dropdwonSlice/fetchLovData",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/myReports/fetchLovData.action?reportId=${data?.reportId}`)
      .then((res) => res.data.data.result);
    return res;
  }
);

export const fetchLovGridData = createAsyncThunk(
  "dropdwonSlice/fetchLovGridData",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/myReports/fetchLovGridData.action?paramId=${data?.paramId}`)
      .then((res) => res.data.data.result);
    return res;
  }
);

export const generateReport = createAsyncThunk(
  "dropdownSlice/generateReport",
  async (data) => {
    const { rptId, rptIdHolder1, SIGN, ...params } = data;
    const queryString = new URLSearchParams({
      rptId,
      rptIdHolder1,
      SIGN,
      ...params,
    }).toString();

    const res = await axiosInstance
      .get(`${url}/myReports/generateReport.action?${queryString}`, {
        responseType: "arraybuffer",
      })
      .then((res) => res.data);
    return res;
  }
);

export const fetchAttendanceEntries = createAsyncThunk(
  "dropdwonSlice/fetchAttendanceEntries",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchAttendance.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchAttendanceDetail = createAsyncThunk(
  "dropdwonSlice/fetchAttendanceDetail",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchAttendanceDetail.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&attId_id=${data?.attId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchNdovupayWallet = createAsyncThunk(
  "dropdwonSlice/fetchNdovupayWallet",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/py/fetchNdovupayWallet.action`)
      .then((res) => res.data?.jsonData?.data?.wallets);
    return res;
  }
);

export const fetchOrganization = createAsyncThunk(
  "dropdwonSlice/fetchOrganization",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/py/fetchOrganization.action`)
      .then((res) => res.data?.data);
    return res;
  }
);

export const fetchPaymentHeader = createAsyncThunk(
  "dropdwonSlice/fetchPaymentHeader",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/py/fetchPaymentHeader.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPaymentDetails = createAsyncThunk(
  "dropdwonSlice/fetchPaymentDetails",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/py/fetchPaymentDetails.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&phId=${data?.phId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchWalletUsers = createAsyncThunk(
  "dropdwonSlice/fetchWalletUsers",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/py/fetchWalletUsers.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }&phId=${data?.phId}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchAttendanceLocations = createAsyncThunk(
  "dropdwonSlice/fetchAttendanceLocations",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/gis/getAttendanceLocations.action?date=${data?.date}`)
      .then((res) => res.data);
    return res;
  }
);

export const getUserActivities = createAsyncThunk(
  "dropdwonSlice/getUserActivities",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/usr/getUserActivities.action?date=${data?.date}&usrId=${data?.usrId}&usrFullNames=${data?.ppFullName}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchShiftType = createAsyncThunk(
  "dropdwonSlice/fetchShiftType",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/shift/fetchShiftType.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&cpId=${data?.cpId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchShiftSchedule = createAsyncThunk(
  "dropdwonSlice/fetchShiftSchedule",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/shift/fetchShiftSchedule.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&cpId=${data?.cpId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPersonnelSummary = createAsyncThunk(
  "dropdwonSlice/fetchPersonnelSummary",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/fetchPersonnelSummary.action`)
      .then((res) => res.data);
    return res;
  }
);



export const fetchOrganogram = createAsyncThunk(
  "dropdwonSlice/fetchOrganogram",
  async () => {
    const res = await axiosInstance
      .get(`${url}/hr/fetchOrganogram.action`)
      .then((res) => res.data);
    return res;
  }
);

export const getBalances = createAsyncThunk(
  "dropdwonSlice/getBalances",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/shift/getBalances.action`)
      .then((res) => res.data);
    return res;
  }
);

export const fetchTariffs = createAsyncThunk(
  "dropdwonSlice/fetchTariffs",
  async (data) => {
    const res = await axios
      .get(`${ndovuUrl}/api/fetchTariffs.action`)
      .then((res) => res.data);
    return res;
  }
);

export const fetchCasual = createAsyncThunk(
  "dropdwonSlice/fetchCasual",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchCasual.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&criteria=${data?.criteria ?? null}&txtSearch=${
          data?.txtSearch ?? null
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchThirdPartyUser = createAsyncThunk(
  "dropdwonSlice/fetchThirdPartyUser",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/usr/getUserFrombilling.action?usrId=${data.usrId}`)
      .then((res) => res);
    return res;
  }
);

export const fetchConnectedUser = createAsyncThunk(
  "dropdwonSlice/fetchConnectedUser",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/usr/fetchConnectedUser.action?ppId=${data?.ppId}`)
      .then((res) => res);
    return res;
  }
);

export const fetchStoreItem = createAsyncThunk(
  "dropdwonSlice/fetchStoreItem",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/asset/fetchStoreItem.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchItemLedger = createAsyncThunk(
  "dropdwonSlice/fetchItemLedger",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/asset/fetchItemLedger.action?itemId=${data?.itemId}&limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchFixedAsset = createAsyncThunk(
  "dropdwonSlice/fetchFixedAsset",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/asset/fetchFixedAsset.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchStoreRequest = createAsyncThunk(
  "dropdwonSlice/fetchStoreRequest",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/asset/fetchStoreRequest.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}&srStatus=${data?.srStatus}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchAssetTransfer = createAsyncThunk(
  "dropdwonSlice/fetchAssetTransfer",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/asset/fetchAssetTransfer.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchAudit = createAsyncThunk(
  "dropdwonSlice/fetchAudit",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/aud/fetchAuditLogs.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&username=${data?.username ?? null}&table=${data?.table ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchShiftRequest = createAsyncThunk(
  "dropdwonSlice/fetchShiftRequest",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/shift/fetchShiftRequest.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}&criteria=${
          data?.criteria ?? null
        }&txtSearch=${data?.txtSearch ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const generateLeaveReport = createAsyncThunk(
  "dropdownSlice/generateLeaveReport",
  async (data) => {
    const { laId } = data;
    const queryString = new URLSearchParams({
      laId,
    }).toString();

    const res = await axiosInstance
      .get(`${url}/myReports/direct_reports_leaveform.action?${queryString}`, {
        responseType: "arraybuffer",
      })
      .then((res) => res.data);
    return res;
  }
);

export const fetchLvBals = createAsyncThunk(
  "dropdwonSlice/fetchLvBals",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchLvBals.action?fpPyear_id=${data?.fpPyear_id}&ltId_id=${data?.ltId_id}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchReturnDate = createAsyncThunk(
  "dropdwonSlice/fetchReturnDate",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchReturnDate.action?startDate=${data?.startDate}&daysTaken=${data?.daysTaken}&dueDate=${data?.dueDate}
        `
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchFilesSecured = createAsyncThunk(
  "dropdownSlice/fetchFilesSecured",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/file/secured/${data?.file}`, {
        responseType: "blob",  
      });
 
      const blob = new Blob([response.data], { type: response.data.type });
      const fileUrl = window.URL.createObjectURL(blob);
      return fileUrl;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
 

export const dropdownSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    clearDropObj: () => {
      return { ...initialState };
    },
  },

  extraReducers: (builder) => {
    builder

    .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        const { key, data, total } = action.payload;

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: data || [] };
        state.count = { ...state.count, [key]: total || 0 };
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        const key = action.payload?.key || "unknown";

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: [] };
        state.count = { ...state.count, [key]: 0 };
      })
      

      .addCase(fetchCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.countryData = action.payload;
      })
      .addCase(fetchCountry.rejected, (state) => {
        state.loading = false;
        state.countryData = [];
      })

      .addCase(fetchGender.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGender.fulfilled, (state, action) => {
        state.loading = false;
        state.genderData = action.payload;
      })
      .addCase(fetchGender.rejected, (state) => {
        state.loading = false;
        state.genderData = [];
      })

      .addCase(fetchStaffGrade.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffGrade.fulfilled, (state, action) => {
        state.loading = false;
        state.staffGradeData = action?.payload?.data?.result;
        state.staffGradeDataCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffGrade.rejected, (state) => {
        state.loading = false;
        state.staffGradeData = [];
        state.staffGradeDataCount = 0;
      })
      .addCase(fetchStaffPositionByGrade.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffPositionByGrade.fulfilled, (state, action) => {
        state.loading = false;
        state.staffPositionByGrade = action.payload;
      })
      .addCase(fetchStaffPositionByGrade.rejected, (state) => {
        state.loading = false;
        state.staffPositionByGrade = [];
      })

      .addCase(fetchStaffTerm.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffTerm.fulfilled, (state, action) => {
        state.loading = false;
        state.staffTerm = action?.payload?.data?.result;
        state.staffTermCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffTerm.rejected, (state) => {
        state.loading = false;
        state.staffTerm = [];
      })

      .addCase(fetchStaffCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.staffCategory = action?.payload?.data?.result;
        state.staffCategoryCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffCategory.rejected, (state) => {
        state.loading = false;
        state.staffCategory = [];
        state.staffCategoryCount = 0;
      })

      .addCase(fetchPayrollType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPayrollType.fulfilled, (state, action) => {
        state.loading = false;
        state.payrollType = action?.payload?.data?.result;
        state.payrollTypeCount = action?.payload?.data?.total;
      })
      .addCase(fetchPayrollType.rejected, (state) => {
        state.loading = false;
        state.payrollType = [];
        state.payrollTypeCount = 0;
      })

      .addCase(fetchCoBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCoBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.coBranch = action?.payload?.data?.result;
        state.coBranchCount = action?.payload?.data?.total;
      })
      .addCase(fetchCoBranch.rejected, (state) => {
        state.loading = false;
        state.coBranch = [];
        state.coBranchCount = 0;
      })

      .addCase(fetchDepts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDepts.fulfilled, (state, action) => {
        state.loading = false;
        state.depts = action?.payload?.data?.result;
        state.deptsCount = action?.payload?.data?.total;
      })
      .addCase(fetchDepts.rejected, (state) => {
        state.loading = false;
        state.depts = [];
        state.deptsCount = 0;
      })

      .addCase(fetchSections.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSections.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action?.payload?.data?.result;
        state.sectionsCount = action?.payload?.data?.total;
      })
      .addCase(fetchSections.rejected, (state) => {
        state.loading = false;
        state.sections = [];
        state.sectionsCount = 0;
      })

      .addCase(fetchStaffStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.staffStatus = action?.payload?.data?.result;
        state.staffStatusCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffStatus.rejected, (state) => {
        state.loading = false;
        state.staffStatus = [];
        state.staffStatusCount = 0;
      })

      .addCase(fetchSocialRel.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSocialRel.fulfilled, (state, action) => {
        state.loading = false;
        state.socialRel = action.payload;
      })
      .addCase(fetchSocialRel.rejected, (state) => {
        state.loading = false;
        state.socialRel = [];
      })

      .addCase(fetchFiscYear.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFiscYear.fulfilled, (state, action) => {
        state.loading = false;
        state.fiscalYear = action?.payload?.data?.result;
        state.fiscalYearCount = action?.payload?.data?.total;
      })
      .addCase(fetchFiscYear.rejected, (state) => {
        state.loading = false;
        state.fiscalYear = [];
        state.fiscalYearCount = 0;
      })

      .addCase(fetchFiscPeriods.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFiscPeriods.fulfilled, (state, action) => {
        state.loading = false;
        state.fiscalPeriod = action?.payload?.data?.result;
        state.fiscalPeriodCount = action?.payload?.data?.total;
      })
      .addCase(fetchFiscPeriods.rejected, (state) => {
        state.loading = false;
        state.fiscalPeriod = [];
        state.fiscalPeriodCount = 0;
      })

      .addCase(fetchFiscPeriod.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFiscPeriod.fulfilled, (state, action) => {
        state.loading = false;
        state.fiscalP = action?.payload?.data?.result;
        state.fiscalPCount = action?.payload?.data?.total;
      })
      .addCase(fetchFiscPeriod.rejected, (state) => {
        state.loading = false;
        state.fiscalP = [];
        state.fiscalPCount = 0;
      })

      .addCase(fetchBank.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBank.fulfilled, (state, action) => {
        state.loading = false;
        state.bank = action?.payload?.data?.result;
        state.bankCount = action?.payload?.data?.total;
      })
      .addCase(fetchBank.rejected, (state) => {
        state.loading = false;
        state.bank = [];
        state.bankCount = 0;
      })

      .addCase(fetchBankBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBankBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.bankBranch = action?.payload?.data?.result;
        state.bankBranchCount = action?.payload?.data?.total;
      })
      .addCase(fetchBankBranch.rejected, (state) => {
        state.loading = false;
        state.bankBranch = [];
        state.bankBranchCount = 0;
      })

      .addCase(fetchSlipHeader.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSlipHeader.fulfilled, (state, action) => {
        state.loading = false;
        state.slipHeader = action?.payload?.data?.result;
        state.slipHeaderCount = action?.payload?.data?.total;
      })
      .addCase(fetchSlipHeader.rejected, (state) => {
        state.loading = false;
        state.slipHeader = [];
        state.slipHeaderCount = 0;
      })

      .addCase(fetchPrItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrItem.fulfilled, (state, action) => {
        state.loading = false;
        state.prItem = action?.payload?.data?.result;
        state.prItemCount = action?.payload?.data?.total;
      })
      .addCase(fetchPrItem.rejected, (state) => {
        state.loading = false;
        state.prItem = [];
        state.prItemCount = 0;
      })

      .addCase(fetchPrItp.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrItp.fulfilled, (state, action) => {
        state.loading = false;
        state.prItp = action?.payload?.data?.result;
        state.prItpCount = action?.payload?.data?.total;
      })
      .addCase(fetchPrItp.rejected, (state) => {
        state.loading = false;
        state.prItp = [];
        state.prItpCount = 0;
      })

      .addCase(fetchGlAccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGlAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.glAccount = action?.payload?.data?.result;
        state.glAccountCount = action?.payload?.data?.total;
      })
      .addCase(fetchGlAccount.rejected, (state) => {
        state.loading = false;
        state.glAccount = [];
        state.glAccountCount = 0;
      })

      .addCase(fetchPrFormulas.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrFormulas.fulfilled, (state, action) => {
        state.loading = false;
        state.prFormulas = action?.payload?.data?.result;
        state.prFormulasCount = action?.payload?.data?.total;
      })
      .addCase(fetchPrFormulas.rejected, (state) => {
        state.loading = false;
        state.prFormulas = [];
        state.prFormulasCount = 0;
      })

      .addCase(fetchTaxRate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTaxRate.fulfilled, (state, action) => {
        state.loading = false;
        state.taxRate = action?.payload?.data?.result;
        state.taxRateCount = action?.payload?.data?.total;
      })
      .addCase(fetchTaxRate.rejected, (state) => {
        state.loading = false;
        state.taxRate = [];
        state.taxRateCount = 0;
      })

      .addCase(fetchNhifRate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNhifRate.fulfilled, (state, action) => {
        state.loading = false;
        state.nhifRate = action?.payload?.data?.result;
        state.nhifRateCount = action?.payload?.data?.total;
      })
      .addCase(fetchNhifRate.rejected, (state) => {
        state.loading = false;
        state.nhifRate = [];
        state.nhifRateCount = 0;
      })

      .addCase(fetchLeaveType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveType.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveType = action?.payload?.data?.result;
        state.leaveTypeCount = action?.payload?.data?.total;
      })
      .addCase(fetchLeaveType.rejected, (state) => {
        state.loading = false;
        state.leaveType = [];
        state.leaveTypeCount = 0;
      })

      .addCase(fetchLeaveTypeAnl.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveTypeAnl.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveTypeAnl = action?.payload?.data?.result;
        state.leaveTypeAnlCount = action?.payload?.data?.total;
      })
      .addCase(fetchLeaveTypeAnl.rejected, (state) => {
        state.loading = false;
        state.leaveTypeAnl = [];
        state.leaveTypeAnlCount = 0;
      })

      .addCase(fetchLeaveDay.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveDay.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveDay = action?.payload?.data?.result;
        state.leaveDayCount = action?.payload?.data?.total;
      })
      .addCase(fetchLeaveDay.rejected, (state) => {
        state.loading = false;
        state.leaveDay = [];
        state.leaveDayCount = 0;
      })

      .addCase(fetchLeaveSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveSchedule = action?.payload?.data?.result;
        state.leaveScheduleCount = action?.payload?.data?.total;
      })
      .addCase(fetchLeaveSchedule.rejected, (state) => {
        state.loading = false;
        state.leaveSchedule = [];
        state.leaveScheduleCount = 0;
      })

      .addCase(fetchLeaveApp.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveApp.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveApp = action?.payload?.data?.result;
        state.leaveAppCount = action?.payload?.data?.total;
      })
      .addCase(fetchLeaveApp.rejected, (state) => {
        state.loading = false;
        state.leaveApp = [];
        state.leaveAppCount = 0;
      })

      .addCase(fetchStaffBank.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffBank.fulfilled, (state, action) => {
        state.loading = false;
        state.staffBank = action?.payload?.data?.result;
        state.staffBankCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffBank.rejected, (state) => {
        state.loading = false;
        state.staffBank = [];
        state.staffBankCount = 0;
      })

      .addCase(fetchStaffExempt.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffExempt.fulfilled, (state, action) => {
        state.loading = false;
        state.staffExempt = action?.payload?.data?.result;
        state.staffExemptCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffExempt.rejected, (state) => {
        state.loading = false;
        state.staffExempt = [];
        state.staffExemptCount = 0;
      })

      .addCase(fetchItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItem.fulfilled, (state, action) => {
        state.loading = false;
        state.itemb = action?.payload?.data?.result;
        state.itembCount = action?.payload?.data?.total;
      })
      .addCase(fetchItem.rejected, (state) => {
        state.loading = false;
        state.itemb = [];
        state.itembCount = 0;
      })

      .addCase(fetchPrWefHdr.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrWefHdr.fulfilled, (state, action) => {
        state.loading = false;
        state.prWefHdr = action?.payload?.data?.result;
        state.prWefHdrCount = action?.payload?.data?.total;
      })
      .addCase(fetchPrWefHdr.rejected, (state) => {
        state.loading = false;
        state.prWefHdr = [];
        state.prWefHdrCount = 0;
      })

      .addCase(fetchActiveFnPrd.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveFnPrd.fulfilled, (state, action) => {
        state.loading = false;
        state.activeFnPrd = action?.payload?.data?.result?.[0];
        state.activeFnPrdCount = action?.payload?.data?.total;
      })
      .addCase(fetchActiveFnPrd.rejected, (state) => {
        state.loading = false;
        state.activeFnPrd = [];
        state.activeFnPrdCount = 0;
      })

      .addCase(fetchPrWefDtls.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrWefDtls.fulfilled, (state, action) => {
        state.loading = false;
        state.prWefDtls = action?.payload?.data?.result?.[0];
        state.prWefDtlsCount = action?.payload?.data?.total;
      })
      .addCase(fetchPrWefDtls.rejected, (state) => {
        state.loading = false;
        state.prWefDtls = {};
        state.prWefDtlsCount = 0;
      })

      .addCase(fetchStaffItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffItem.fulfilled, (state, action) => {
        state.loading = false;
        state.staffItem = action?.payload?.data?.result;
        state.staffItemCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffItem.rejected, (state) => {
        state.loading = false;
        state.staffItem = [];
        state.staffItemCount = 0;
      })

      .addCase(fetchActiveFiscYear.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveFiscYear.fulfilled, (state, action) => {
        state.loading = false;
        state.activeFiscYear = action?.payload?.data?.result;
        state.activeFiscYearCount = action?.payload?.data?.total;
      })
      .addCase(fetchActiveFiscYear.rejected, (state) => {
        state.loading = false;
        state.activeFiscYear = [];
        state.activeFiscYearCount = 0;
      })

      .addCase(fetchActiveFiscMonth.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveFiscMonth.fulfilled, (state, action) => {
        state.loading = false;
        state.activeFiscMonth = action?.payload?.data?.result;
        state.activeFiscMonthCount = action?.payload?.data?.total;
      })
      .addCase(fetchActiveFiscMonth.rejected, (state) => {
        state.loading = false;
        state.activeFiscMonth = [];
        state.activeFiscMonthCount = 0;
      })

      .addCase(fetchPrSlipMsg.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrSlipMsg.fulfilled, (state, action) => {
        state.loading = false;
        state.prSlipMsg = action?.payload?.data?.result;
        state.prSlipMsgCount = action?.payload?.data?.total;
      })
      .addCase(fetchPrSlipMsg.rejected, (state) => {
        state.loading = false;
        state.prSlipMsg = [];
        state.prSlipMsgCount = 0;
      })

      .addCase(fetchFiscPeriodsII.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFiscPeriodsII.fulfilled, (state, action) => {
        state.loading = false;
        state.fiscPeriodsII = action?.payload?.data?.result;
        state.fiscPeriodsIICount = action?.payload?.data?.total;
      })
      .addCase(fetchFiscPeriodsII.rejected, (state) => {
        state.loading = false;
        state.fiscPeriodsII = [];
        state.fiscPeriodsIICount = 0;
      })

      .addCase(fetchStaffNetPays.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffNetPays.fulfilled, (state, action) => {
        state.loading = false;
        state.staffNetPays = action?.payload?.data?.result;
        state.staffNetPaysCount = action?.payload?.data?.total;
      })
      .addCase(fetchStaffNetPays.rejected, (state) => {
        state.loading = false;
        state.staffNetPays = [];
        state.staffNetPaysCount = 0;
      })

      .addCase(fetchCasualType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCasualType.fulfilled, (state, action) => {
        state.loading = false;
        state.casualType = action?.payload?.data?.result;
        state.casualTypeCount = action?.payload?.data?.total;
      })
      .addCase(fetchCasualType.rejected, (state) => {
        state.loading = false;
        state.casualType = [];
        state.casualTypeCount = 0;
      })

      .addCase(fetchCasualProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCasualProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.casualProfile = action?.payload?.data?.result;
        state.casualProfileCount = action?.payload?.data?.total;
      })
      .addCase(fetchCasualProfile.rejected, (state) => {
        state.loading = false;
        state.casualProfile = [];
        state.casualProfileCount = 0;
      })

      .addCase(fetchAttendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.attendance = action?.payload?.data?.result;
        state.attendanceCount = action?.payload?.data?.total;
      })
      .addCase(fetchAttendance.rejected, (state) => {
        state.loading = false;
        state.attendance = [];
        state.attendanceCount = 0;
      })

      .addCase(fetchCasualPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCasualPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.casualPayment = action?.payload?.data?.result;
        state.casualPaymentCount = action?.payload?.data?.total;
      })
      .addCase(fetchCasualPayment.rejected, (state) => {
        state.loading = false;
        state.casualPayment = [];
        state.casualPaymentCount = 0;
      })

      .addCase(fetchCasualPaymentDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCasualPaymentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.casualPaymentDetails = action?.payload?.data?.result;
        state.casualPaymentDetailsCount = action?.payload?.data?.total;
      })
      .addCase(fetchCasualPaymentDetails.rejected, (state) => {
        state.loading = false;
        state.casualPaymentDetails = [];
        state.casualPaymentDetailsCount = 0;
      })

      .addCase(fetchUserMainScreen.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserMainScreen.fulfilled, (state, action) => {
        state.loading = false;
        state.userMainScreen = action?.payload?.data?.result;
        state.userMainScreenCount = action?.payload?.data?.total;
      })
      .addCase(fetchUserMainScreen.rejected, (state) => {
        state.loading = false;
        state.userMainScreen = [];
        state.userMainScreenCount = 0;
      })

      .addCase(fetchAssignedRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssignedRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.assignedRoles = action?.payload;
      })
      .addCase(fetchAssignedRoles.rejected, (state) => {
        state.loading = false;
        state.assignedRoles = [];
      })

      .addCase(assignRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(assignRole.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(assignRole.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchReportTree.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportTree.fulfilled, (state, action) => {
        state.loading = false;
        state.reportTree = action?.payload;
      })
      .addCase(fetchReportTree.rejected, (state) => {
        state.loading = false;
        state.reportTree = [];
      })

      .addCase(fetchLovData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLovData.fulfilled, (state, action) => {
        state.loading = false;
        state.lovData = action?.payload;
      })
      .addCase(fetchLovData.rejected, (state) => {
        state.loading = false;
        state.lovData = [];
      })

      .addCase(fetchLovGridData.pending, (state) => {
        state.loadingGrid = true;
      })
      .addCase(fetchLovGridData.fulfilled, (state, action) => {
        state.loadingGrid = false;
        state.lovGrid = action?.payload;
      })
      .addCase(fetchLovGridData.rejected, (state) => {
        state.loadingGrid = false;
        state.lovGrid = [];
      })

      .addCase(generateReport.pending, (state) => {
        state.loadingGenerateReport = true;
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        state.loadingGenerateReport = false;
      })
      .addCase(generateReport.rejected, (state) => {
        state.loadingGenerateReport = false;
      })

      .addCase(fetchAttendanceEntries.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttendanceEntries.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceEntries = action?.payload?.data?.result;
        state.attendanceEntriesCount = action?.payload?.data?.total;
      })
      .addCase(fetchAttendanceEntries.rejected, (state, action) => {
        state.loading = false;
        state.attendanceEntries = [];
        state.attendanceEntriesCount = 0;
      })

      .addCase(fetchAttendanceDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttendanceDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceDetails = action?.payload?.data?.result;
        state.attendanceDetailsCount = action?.payload?.data?.total;
      })
      .addCase(fetchAttendanceDetail.rejected, (state, action) => {
        state.loading = false;
        state.attendanceDetails = [];
        state.attendanceDetailsCount = 0;
      })

      .addCase(fetchNdovupayWallet.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNdovupayWallet.fulfilled, (state, action) => {
        state.loading = false;
        state.ndovuWallet = action?.payload;
      })
      .addCase(fetchNdovupayWallet.rejected, (state, action) => {
        state.loading = false;
        state.ndovuWallet = [];
      })

      .addCase(fetchOrganization.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.organization = action?.payload?.result;
        state.orgCode = action?.payload?.orgCode;
        state.orgWalletCode = action?.payload?.walletCode;
      })
      .addCase(fetchOrganization.rejected, (state, action) => {
        state.loading = false;
        state.organization = {};
        state.orgCode = "";
        state.orgWalletCode = "";
      })

      .addCase(fetchPaymentHeader.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPaymentHeader.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentHeader = action?.payload?.data?.result;
        state.paymentHeaderCount = action?.payload?.data?.total;
      })
      .addCase(fetchPaymentHeader.rejected, (state, action) => {
        state.loading = false;
        state.paymentHeader = [];
        state.paymentHeaderCount = 0;
      })

      .addCase(fetchPaymentDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPaymentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentDetails = action?.payload?.data?.result;
        state.paymentDetailsCount = action?.payload?.data?.total;
      })
      .addCase(fetchPaymentDetails.rejected, (state, action) => {
        state.loading = false;
        state.paymentDetails = [];
        state.paymentDetailsCount = 0;
      })

      .addCase(fetchWalletUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWalletUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.walletUsers = action?.payload?.data?.result;
        state.walletUsersCount = action?.payload?.data?.total;
      })
      .addCase(fetchWalletUsers.rejected, (state, action) => {
        state.loading = false;
        state.walletUsers = [];
        state.walletUsersCount = 0;
      })
      .addCase(fetchAttendanceLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttendanceLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locationDetails = action?.payload?.data?.result;
      })
      .addCase(fetchAttendanceLocations.rejected, (state, action) => {
        state.loading = false;
        state.locationDetails = [];
      })

      .addCase(fetchShiftType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShiftType.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftType = action?.payload?.data?.result;
        state.shiftTypeCount = action?.payload?.data?.total;
      })
      .addCase(fetchShiftType.rejected, (state, action) => {
        state.loading = false;
        state.shiftType = [];
        state.shiftTypeCount = 0;
      })

      .addCase(fetchShiftSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShiftSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftSchedule = action?.payload?.data?.result;
        state.shiftScheduleCount = action?.payload?.data?.total;
      })
      .addCase(fetchShiftSchedule.rejected, (state, action) => {
        state.loading = false;
        state.shiftSchedule = [];
        state.shiftScheduleCount = 0;
      })

      .addCase(fetchPersonnelSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPersonnelSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.personnelSummary = action?.payload?.data;
      })
      .addCase(fetchPersonnelSummary.rejected, (state, action) => {
        state.loading = false;
        state.personnelSummary = [];
      })

      .addCase(getBalances.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBalances.fulfilled, (state, action) => {
        state.loading = false;
        state.balances = action?.payload?.data?.Balance;
        state.MBs = action?.payload?.data?.MBs;
      })
      .addCase(getBalances.rejected, (state, action) => {
        state.loading = false;
        state.balances = "";
        state.MBs = "";
      })

      .addCase(fetchTariffs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTariffs.fulfilled, (state, action) => {
        state.loading = false;
        state.tariffs = action?.payload?.data?.result;
      })
      .addCase(fetchTariffs.rejected, (state, action) => {
        state.loading = false;
        state.tariffs = [];
      })
      .addCase(fetchStaffPosition.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.staffPosition = action?.payload?.data?.result;
      })
      .addCase(fetchStaffPosition.rejected, (state, action) => {
        state.loading = false;
        state.staffPosition = [];
      })

      .addCase(fetchThirdPartyUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchThirdPartyUser.fulfilled, (state, action) => {
        state.loading = false;
        state.thirdPartyData = action?.payload?.data?.jsonData;
      })
      .addCase(fetchThirdPartyUser.rejected, (state, action) => {
        state.loading = false;
        state.thirdPartyData = [];
      })

      .addCase(fetchConnectedUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchConnectedUser.fulfilled, (state, action) => {
        state.loading = false;
        state.connectedUserData = action?.payload?.data?.data?.result;
      })
      .addCase(fetchConnectedUser.rejected, (state, action) => {
        state.loading = false;
        state.connectedUserData = [];
        console.log("state", state);
      })

      .addCase(getUserActivities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserActivities.fulfilled, (state, action) => {
        state.loading = false;
        state.userActivityData = action?.payload?.data?.data?.result;
      })
      .addCase(getUserActivities.rejected, (state, action) => {
        state.loading = false;
        state.userActivityData = [];
        console.log("state", state);
      })

      .addCase(fetchCasual.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCasual.fulfilled, (state, action) => {
        state.loading = false;
        state.casualData = action?.payload?.data?.result;
        state.casualCount = action?.payload?.data?.total;
      })
      .addCase(fetchCasual.rejected, (state, action) => {
        state.loading = false;
        state.casualData = [];
        state.casualCount = 0;
      })

      .addCase(fetchStoreItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStoreItem.fulfilled, (state, action) => {
        state.loading = false;
        state.storeItemData = action?.payload?.data?.result;
        state.storeItemCount = action?.payload?.data?.total;
      })
      .addCase(fetchStoreItem.rejected, (state, action) => {
        state.loading = false;
        state.storeItemData = [];
        state.storeItemCount = 0;
      })

      .addCase(fetchItemLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.itemLedgerData = action?.payload?.data?.result;
        state.itemLedgerCount = action?.payload?.data?.total;
      })
      .addCase(fetchItemLedger.rejected, (state, action) => {
        state.loading = false;
        state.itemLedgerData = [];
        state.itemLedgerCount = 0;
      })

      .addCase(fetchFixedAsset.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFixedAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.fixedAssetsData = action?.payload?.data?.result;
        state.fixedAssetsCount = action?.payload?.data?.total;
      })
      .addCase(fetchFixedAsset.rejected, (state, action) => {
        state.loading = false;
        state.fixedAssetsData = [];
        state.fixedAssetsCount = 0;
      })

      .addCase(fetchStoreRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStoreRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.storeRequestData = action?.payload?.data?.result;
        state.storeRequestCount = action?.payload?.data?.total;
      })
      .addCase(fetchStoreRequest.rejected, (state, action) => {
        state.loading = false;
        state.storeRequestData = [];
        state.storeRequestCount = 0;
      })

      .addCase(fetchAssetTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssetTransfer.fulfilled, (state, action) => {
        state.loading = false;
        state.assetTransferData = action?.payload?.data?.result;
        state.assetTransferCount = action?.payload?.data?.total;
      })
      .addCase(fetchAssetTransfer.rejected, (state, action) => {
        state.loading = false;
        state.assetTransferData = [];
        state.assetTransferCount = 0;
      })

      .addCase(fetchAudit.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAudit.fulfilled, (state, action) => {
        state.loading = false;
        state.auditData = action?.payload?.data?.result;
        state.auditCount = action?.payload?.data?.total;
      })
      .addCase(fetchAudit.rejected, (state, action) => {
        state.loading = false;
        state.auditData = [];
        state.auditCount = 0;
      })

      .addCase(fetchShiftRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShiftRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftReq = action?.payload?.data?.result;
        state.shiftReqCount = action?.payload?.data?.total;
      })
      .addCase(fetchShiftRequest.rejected, (state, action) => {
        state.loading = false;
        state.shiftReq = [];
        state.shiftReqCount = 0;
      })

      .addCase(generateLeaveReport.pending, (state) => {
        state.loadingGenerateReport = true;
      })
      .addCase(generateLeaveReport.fulfilled, (state, action) => {
        state.loadingGenerateReport = false;
      })
      .addCase(generateLeaveReport.rejected, (state) => {
        state.loadingGenerateReport = false;
      })

      .addCase(fetchLvBals.pending, (state) => {
        state.loadingBal = true;
      })
      .addCase(fetchLvBals.fulfilled, (state, action) => {
        state.loadingBal = false;
        state.leaveBal = action?.payload?.data?.result;
      })
      .addCase(fetchLvBals.rejected, (state) => {
        state.loadingBal = false;
        state.leaveBal = [];
      })

      .addCase(fetchReturnDate.pending, (state) => {
        state.loadingReturnDate = true;
      })
      .addCase(fetchReturnDate.fulfilled, (state, action) => {
        state.loadingReturnDate = false;
        state.returnDate = action?.payload?.jsonData;
      })
      .addCase(fetchReturnDate.rejected, (state) => {
        state.loadingReturnDate = false;
        state.returnDate = null;
      })

      .addCase(fetchOrganogram.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrganogram.fulfilled, (state, action) => {
        state.loading = false;
        state.organogram = action?.payload?.data?.result?.[0];
      })
      .addCase(fetchOrganogram.rejected, (state) => {
        state.loading = false;
        state.organogram = [];
      });
  },
});

export default dropdownSlice.reducer;
export const {
  handleSideMenuCollapse,
  setResellerId,
  cleanResellerId,
  setLegendClickStatus,
  cleanLegendClickStatus,
  clearDropObj,
} = dropdownSlice.actions;
